"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["onLoad", "onError"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrame = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var delay_render_1 = require("./delay-render");

var IFrameRefForwarding = function IFrameRefForwarding(_ref, ref) {
  var onLoad = _ref.onLoad,
      onError = _ref.onError,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useState)(function () {
    return (0, delay_render_1.delayRender)("Loading <IFrame> with source ".concat(props.src));
  }),
      _ref3 = _slicedToArray(_ref2, 1),
      handle = _ref3[0];

  var didLoad = (0, react_1.useCallback)(function (e) {
    (0, delay_render_1.continueRender)(handle);
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(e);
  }, [handle, onLoad]);
  var didGetError = (0, react_1.useCallback)(function (e) {
    (0, delay_render_1.continueRender)(handle);

    if (onError) {
      onError(e);
    } else {
      console.error('Error loading iframe:', e, 'Handle the event using the onError() prop to make this message disappear.');
    }
  }, [handle, onError]);
  return (0, jsx_runtime_1.jsx)("iframe", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    onError: didGetError,
    onLoad: didLoad
  }));
};

exports.IFrame = (0, react_1.forwardRef)(IFrameRefForwarding);